import { Instagram, Facebook } from "lucide-react";

export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/best.escape.holidays/",
  facebook: "https://www.facebook.com/BEHolidays/",
};

export function SocialIcons({ className = "", iconClassName = "h-4 w-4" }) {
  return (
    <div className={`social-links ${className}`}>
      <a
        href={SOCIAL_LINKS.instagram}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="social-instagram-link"
        aria-label="Follow us on Instagram"
        className="flex items-center justify-center rounded-full bg-white/10 p-2 text-current transition-colors hover:bg-gradient-to-br hover:from-[#f58529] hover:via-[#dd2a7b] hover:to-[#8134af] hover:text-white"
      >
        <Instagram className={iconClassName} />
      </a>
      <a
        href={SOCIAL_LINKS.facebook}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="social-facebook-link"
        aria-label="Follow us on Facebook"
        className="flex items-center justify-center rounded-full bg-white/10 p-2 text-current transition-colors hover:bg-[#1877F2] hover:text-white"
      >
        <Facebook className={iconClassName} />
      </a>
    </div>
  );
}
